<template>
  <b-carousel
    :ref="slideId"
    :id="slideId"
    v-model="slide"
    :interval="settingsInterval"
    :controls="controls"
    :indicators="indicators"
    background="#FFFFFF"
    @sliding-start="handleSlidingStart"
    @sliding-end="handleSlidingEnd"
    :no-touch="noTouch"
    :fade="fadeTransition"
  >
    <b-carousel-slide id="TableView">
      <template #img>
        <log-table-view
          :resource="resource"
          :tasks="userDataTasks"
          :log-docs-all="userDataLogDocsAll"
          @log-row-clicked="handleLogTableRowClick"
          @go-to-docs-view="handleGoToDocsViewClick"
        />
      </template>
    </b-carousel-slide>

    <b-carousel-slide id="DetailView">
      <template #img>
        <log-detail-view
          v-if="selectedLog"
          :resource="resource"
          :settings="settings"
          :user-data="userData"
          :log="selectedLog"
          @log-row-clicked="handleLogTableRowClick"
        />
      </template>
    </b-carousel-slide>

    <b-carousel-slide id="DocsView">
      <template #img>
        <log-docs-view
          :resource="resource"
          :items="userDataTasks"
          :log-docs-all="userDataLogDocsAll"
          @log-row-clicked="handleLogTableRowClick"
          @go-to-docs-view="handleGoToDocsViewClick"
        />
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>
<script>
import LogTableView from "./logTableView";
import LogDocsView from "./logDocsView";
import LogDetailView from "./logDetailsView";
import DefaultLogs from "../../../assets/json/defaultLogs.json";
export default {
  name: "ToDo_SlideView",
  components: {
    LogTableView,
    LogDetailView,
    LogDocsView
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    }
  },
  created() {},
  mounted() {},
  computed: {
    /* SETTINGS */
    /* SETTINGS */
    settingsInterval() {
      return 0;
      return this.settings && this.settings.user && this.settings.user.interval
        ? this.settings.user.interval * 1000
        : 4;
    },
    /* DATA */
    userDataTasks() {
      return this.userData && this.userData.tasks ? this.userData.tasks : [];
    },
    userDataLogDocsAll() {
      let docs = [];
      if (
        this.userData &&
        this.userData.logs &&
        Array.isArray(this.userData.logs)
      ) {
        this.userData.logs.forEach(aLog => {
          if (aLog.docs && Array.isArray(aLog.docs) && aLog.docs.length > 0) {
            docs = [...docs, ...aLog.docs];
          }
        });
      }
      return docs;
    }
  },
  methods: {
    handleGoBack() {
      this.$refs[this.slideId].setSlide(0);
    },
    handleLogTableRowClick(logObj) {
      //Go to Detail View
      this.selectedLog = logObj;
      this.$refs[this.slideId].setSlide(1);
    },
    handleGoToDocsViewClick() {
      this.$refs[this.slideId].setSlide(2);
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidTp) {}
  },
  data() {
    return {
      DefaultLogs,
      selectedLog: {},
      assetsURLHome: "", //assets/apps/todo/',
      /* SLIDE INFO*/
      slideId: "audioSlides",
      controls: false,
      indicators: false,
      noTouch: false,
      fadeTransition: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
